import { render, staticRenderFns } from "./EmployeeMpfInfo.vue?vue&type=template&id=397d565c"
import script from "./EmployeeMpfInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeMpfInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports